"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/** @jsx jsx */
const carabiners_1 = require("@clearsummit/carabiners");
const core_1 = require("@emotion/core");
const react_router_dom_1 = require("react-router-dom");
const styled_react_1 = __importDefault(require("./styled-react"));
const styles_scss_1 = __importDefault(require("./styles.scss"));
const StatefulNavItem = (props) => {
    const { path, className, label, onClick, icon, selected, css, testId } = props;
    return ((0, core_1.jsx)(react_router_dom_1.Link, { className: (0, carabiners_1.joinStr)(styles_scss_1.default.statefulAnchor, className), css: css || styled_react_1.default.statefulAnchor(selected), to: path, onClick: onClick },
        (0, core_1.jsx)("svg", { width: "24", height: "24" },
            (0, core_1.jsx)("image", { xlinkHref: icon, width: "24", height: "24" })),
        (0, core_1.jsx)("span", { "data-testid": testId }, label)));
};
StatefulNavItem.defaultProps = {
    className: undefined,
    css: null,
    onClick: undefined,
    testId: undefined,
    selected: false
};
exports.default = StatefulNavItem;
